// extracted by mini-css-extract-plugin
module.exports = {"header":"Search_header__XqDIh","menus":"Search_menus__XyJFQ","noresults":"Search_noresults__SOES1"};